export const OFFER_KEYS = {
  SELF_GUIDED_DEFENSIE: "zelfstandig_defensie",
  GUIDED_DEFENSIE: "begeleid_defensie",
  GUIDED_VEILIGHEIDSDIENSTEN: "begeleid_veiligheidsdiensten",
};

export const offerCatalog = [
  {
    id: OFFER_KEYS.SELF_GUIDED_DEFENSIE,
    productKey: OFFER_KEYS.SELF_GUIDED_DEFENSIE,
    title: "Zelfstandig Defensie",
    badge: "12 weken",
    priceLabel: "€89,-",
    buttonLabel: "Bestel en betaal",
    visualVariant: "self",
    description:
      "Geschikt als je al een redelijke basis hebt, zelfstandig kunt trainen en bereid bent onderdelen te schalen waar nodig.",
    features: [
      "✓ Militair handboek",
      "✓ Onderdelen 01 t/m 05",
      "✓ 12-weekse trainingsstructuur / PDF",
      "✓ Schaalinstructies om verantwoord aan te passen",
    ],
    excludedFeatures: [
      "✕ Geen intake of persoonlijke bijsturing",
      "✕ Geen coaching/contact",
    ],
  },
  {
    id: OFFER_KEYS.GUIDED_DEFENSIE,
    productKey: OFFER_KEYS.GUIDED_DEFENSIE,
    title: "Begeleid Defensie",
    badge: "12 weken",
    priceLabel: "€189,-",
    buttonLabel: "Bestel en betaal",
    visualVariant: "guided",
    description:
      "Verstandiger als je nog moet opbouwen, klachten hebt, of niet zeker weet hoe je het programma verantwoord moet schalen.",
    features: [
      "✓ Intakegesprek",
      "✓ Assessment van startniveau",
      "✓ Programma afgestemd op jouw Defensie-doel",
      "✓ Follow-up/contact tijdens je voorbereiding",
      "✓ Persoonlijke correcties en advies",
      "✓ Militair handboek inbegrepen",
    ],
    excludedFeatures: [],
  },
  {
    id: OFFER_KEYS.GUIDED_VEILIGHEIDSDIENSTEN,
    productKey: OFFER_KEYS.GUIDED_VEILIGHEIDSDIENSTEN,
    title: "Begeleid Veiligheidsdiensten",
    badge: "12 weken",
    priceLabel: "€189,-",
    buttonLabel: "Bestel en betaal",
    visualVariant: "guided",
    description:
      "Voor kandidaten richting politie, brandweer, KMar of veiligheidsdiensten die gericht willen trainen op hun startniveau, functie-eisen en belastbaarheid.",
    features: [
      "✓ Intakegesprek",
      "✓ Movement assessment",
      "✓ Programma afgestemd op jouw richting",
      "✓ Follow-up/contact tijdens je voorbereiding",
      "✓ Persoonlijke correcties en advies",
    ],
    excludedFeatures: [],
  },
];

export const offerVariants = {
  all: [
    OFFER_KEYS.SELF_GUIDED_DEFENSIE,
    OFFER_KEYS.GUIDED_DEFENSIE,
    OFFER_KEYS.GUIDED_VEILIGHEIDSDIENSTEN,
  ],
  defensie: [OFFER_KEYS.SELF_GUIDED_DEFENSIE, OFFER_KEYS.GUIDED_DEFENSIE],
  veiligheidsdiensten: [OFFER_KEYS.GUIDED_VEILIGHEIDSDIENSTEN],
};

export const getOffersByVariant = (variant = "all") => {
  const productKeys = offerVariants[variant] || offerVariants.all;
  return productKeys
    .map((productKey) =>
      offerCatalog.find((offer) => offer.productKey === productKey),
    )
    .filter(Boolean);
};
